import { StateCreator } from 'zustand';
import { getPrequalResults, getSmallBatchDecisions } from '../../api/small-batch-api';
import { getStoreId } from '../../utilities/visitor-cookie';
import { IAppState, IFbsSlice } from './stateTypes';

const createFbsSlice: StateCreator<IAppState, [], [], IFbsSlice> = (set, get) => ({
    // In order to avoid making API calls for the same stock numbers
    // need to independently track the numbers outside of the ones that have just been requested
    fbsStockNumbers: [],
    setFbsStockNumbers: (stockNumbers: number[]) => {
        set({ fbsStockNumbers: stockNumbers });
    },
    fbsData: [],
    isPrequalified: false,
    getFbsDataForStockNumbers: async (stockNumbers: number[]) => {
        // Merge existing stock numbers from current fbsData with the new ones
        const fbsStockNumbers = get().fbsStockNumbers;
        const stockNumbersToGet = stockNumbers.filter((stockNumber) => !fbsStockNumbers.includes(stockNumber));
        if (stockNumbersToGet.length === 0) return;

        const mergedStockNumbers = [...stockNumbersToGet, ...fbsStockNumbers];
        set({ fbsStockNumbers: mergedStockNumbers });
        const uniqueStockNumbers = Array.from(new Set(stockNumbersToGet));

        if (!get().ciamId) {
            await get().setCiam();
        }

        const ciamId = get().ciamId;
        if (uniqueStockNumbers.length > 0) {
            const fbsData = await getSmallBatchDecisions(ciamId, uniqueStockNumbers, getStoreId());
            const updatedFbsData = [...get().fbsData, ...fbsData];
            set({
                fbsData: updatedFbsData,
            });
        }
    },
    getIsPreQualified: async () => {
        const preQualificationData = await getPrequalResults();
        set({ isPrequalified: preQualificationData !== null });
    },
});

export default createFbsSlice;
